import { dataToColors } from "src/util/colors";
import { VERTICAL_STACKED, HORIZONTAL_STACKED, PIE_GRADE, RADAR } from "src/components/Charts/types";

// Em alguns momentos, a ordem das cores enviadas por herança do gráfico simples para os demais gráficos
// pode não estar correta, portanto, antes de enviar suas cores por herança, sempre será feito
// um processamento que transformará o tema de cores atual do gráfico simples em um objeto com todos os enunciados
// do gráfico. Assim a consistência das cores é garantida.
export default function processSimpleChartColors(
  chartType,
  chartSeries = [],
  currentColorArray = [],
) {
  const isGradeQuestionType = [VERTICAL_STACKED, HORIZONTAL_STACKED, PIE_GRADE, RADAR].includes(chartType);
  const newData = (isGradeQuestionType && [...chartSeries].reverse()) || chartSeries;

  const result = dataToColors(newData, currentColorArray);
  return result;
}